<template>
    <div>
        <div class="series-content__item" v-for="(item, i) in noveloutline" :key="i">
            <el-input type="textarea" :value="item.outlineText" readonly autosize
                class="series-content-title"></el-input>
            <div class="yjcz">
                <div class="btn-primary" @click.stop="addNovel(item)">一键创建作品</div>
                <div class="btn-copy btn-primary" @click.stop="copyInnterText(item)">复制内容</div>
            </div>

        </div>
    </div>
</template>
<script>
import { copy } from '@/utils/utils'
export default {
    props: {
        noveloutline: {
            type: Array,
            default() {
                return []
            }
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        editType: {
            type: [String, Number],
            default: ''
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
    methods: {
        addNovel(item){
            console.log('item=',item)
            this.$emit('addNovel',item)
        },
       // 复制正文
        async copyInnterText(item) {
            const success = await copy(item.outlineText);
            if (success) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }
        },
    }
};
</script>
<style lang="scss" scoped>
.series-content__item {
    width: 100%;
    position: relative;
    &:last-child{
        .yjcz{
            &::after{
                height: 0;
            }
        }
    }
}
.yjcz{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 20px;
    padding-bottom: 20px;
    padding-right: 20px;
    position: relative;
    
    &::after{
        content: '';
        position: absolute;
        height: 1px;
        background-color: var(--tech-btn-border1);
        width: 100%;
        bottom: 0px;
    }
    .btn-copy{
        margin-left: 20px;
        width: 100px !important;
    }
    .btn-primary{
        width: 150px;
    }
}
</style>